import React, { Component } from 'react';
import PropTypes from 'prop-types';

// TODO:
// render should
class PopupWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowClosed: (!this.props.src)
        }
    }
    componentDidMount() {
        this.props.src && this.openPopup();
    }

    render() {
        return this.props.children ? this.props.children(this.state.windowClosed) : null;
    }

    openPopup() {
        const { width = screen.width, height = screen.height } = this.props;
        const left = (width >= screen.width) ? 0 : (screen.width - width) / 2;
        const top = (height >= screen.height) ? 0 : (screen.height - height) / 2;
        this.popup = window.open(this.props.src, 'ElearningPlayer', `width=${width}, height=${height}, left=${left}, top=${top}, resizable=no,scrollbars=yes,toolbar=no,menubar=no,location=no,directories=no,status=no`);
        this.timer = setInterval(() => {
            if (this.popup.closed) {
                this.setState({windowClosed: true});
                clearInterval(this.timer);
            }
        }, 1000);
    }
}

PopupWindow.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    children: PropTypes.func,
};

export default PopupWindow;
